import { accountRequiredMessage, unauthorizedMessage } from "../../common";

/** What every route for working on a preset declares: no session, or a guest's. */
export const teamRefusals = {
  UNAUTHORIZED: { message: unauthorizedMessage },
  FORBIDDEN: { message: accountRequiredMessage },
} as const;

export const noSuchPreset = {
  NOT_FOUND: { message: "The preset doesn't exist, or you aren't on its team." },
} as const;
